import React from 'react';
import './NotFound.css'; // Importing custom CSS
import { Link } from 'react-router-dom';
import pagenotfind from '../../images/pagenotfind.avif'
const PageNotFound = () => {
  return (
    <div className="not-found-container d-flex justify-content-center flex-column align-items-center">
      <div className="text-center">
        <img
          src={pagenotfind} // Example image
          alt="404"
          className="not-found-img mb-4"
        />

      </div>

      <div className="text-center">
        <Link to="/" className="primary signin-btn nextbtn p-2 rounded gap-1">
          <i className="fas fa-home mx-2"></i>
          Go Back Home
        </Link>
        </div>
    </div>
  );
};

export default PageNotFound;
